import React, { useState, useCallback } from 'react'
import { Grid } from '@mui/material'

import {
  //   SelectInput,
  SimpleForm,
  TextInput,
  required,
  BooleanInput,
  SelectInput,
  //   useTranslate,
  //   ReferenceInput,
  //   useLocaleState,
  useEditContext,
  Loading,
  useUpdate,
  useNotify,
  useRecordContext,
  useRedirect,
  Confirm,
  // DeleteButton,
} from 'react-admin'
import { COMMON_FIELDS, SERVICES_FIELDS } from '../../providers/localization/constant'
import { EditBase } from '../../components/base'
import CustomServiceToolbarWithPermission from '../../components/domains/services/CustomServiceToolbar'
import { Services } from './type'

const PREFIX = 'resources.services'

const EditForm = (): JSX.Element => {
  const [updateData, setUpdateData] = useState({} as Services)
  const record = useRecordContext()
  const notify = useNotify()
  const [open, setOpen] = useState(false)
  const redirect = useRedirect()
  const handleDialogClose = (): void => setOpen(false)
  const { isLoading: formLoading, record: data } = useEditContext()
  const servicedurationhours = `${Math.floor(data?.service_duration / 60)}`
  const servicedurationminutes = `${data?.service_duration % 60}`
  const [serviceDurationHours, setServiceDurationHours] = useState<string>(servicedurationhours)
  const [serviceDurationMinutes, setServiceDurationMinutes] =
    useState<string>(servicedurationminutes)
  const onError = useCallback(
    (error): void => {
      if (error.response.data.code === '23505') {
        return notify(
          'ra.validation.update_service_fail_by_key' || 'ra.validation.update_service_fail',
          { type: 'error' },
        )
      }
      return notify(error || 'ra.validation.update_service_fail', { type: 'error' })
    },
    [notify],
  )

  const onSuccess = useCallback(async (): Promise<void> => {
    notify('ra.notification.update_service_success', { type: 'success' })
    redirect('/services')
  }, [notify, redirect])

  const [update, { isLoading }] = useUpdate(undefined, undefined, { onError, onSuccess })

  const handleConfirm = useCallback(async (): Promise<void> => {
    await update('services', {
      id: record.id,
      data: { /* encType: 'multipart/form-data',*/ ...updateData },
      // data: {
      //   is_active: updateData?.is_active,
      // },
    })
    handleDialogClose()
  }, [update, updateData, record])

  const handleSubmit = (data): void => {
    const { /* access_branches: accessBranches,*/ ...services } = data
    // email.branch_ids = accessBranches
    setUpdateData(services as Services)
    setOpen(true)
  }
  const validateServiceDuration = (): string | undefined => {
    const hours = parseInt(serviceDurationHours, 10)
    const minutes = parseInt(serviceDurationMinutes, 10)

    if (hours === 0 && minutes === 0) {
      return 'เวลาบริการไม่ถูกต้อง'
    }

    return undefined // Return undefined for no validation error
  }

  const handleHoursChange = (event): void => {
    setServiceDurationHours(event.target.value as string)
  }

  const handleMinutesChange = (event): void => {
    setServiceDurationMinutes(event.target.value as string)
  }

  if (formLoading) return <Loading />
  return (
    <SimpleForm
      onSubmit={handleSubmit}
      toolbar={<CustomServiceToolbarWithPermission encType='application/json' />}
    >
      <Confirm
        isOpen={open}
        loading={isLoading}
        title='Update Service'
        content='Are you sure you want to update this service?'
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
      <Grid container spacing={2} xs={12}>
        <Grid item xs={12} md={6}>
          <TextInput
            source='title_th'
            label={`${SERVICES_FIELDS}.title_th`}
            fullWidth
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            source='title_en'
            label={`${SERVICES_FIELDS}.title_en`}
            fullWidth
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput
            fullWidth
            source='service_duration_hours'
            label={`${SERVICES_FIELDS}.service_duration_hours`}
            choices={[
              { id: '0', name: '0 ชั่วโมง' },
              { id: '1', name: '1 ชั่วโมง' },
              { id: '2', name: '2 ชั่วโมง' },
              { id: '3', name: '3 ชั่วโมง' },
              { id: '4', name: '4 ชั่วโมง' },
            ]}
            onChange={handleHoursChange}
            defaultValue={servicedurationhours}
            validate={[required(), validateServiceDuration]}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput
            source='service_duration_minutes'
            label={`${SERVICES_FIELDS}.service_duration_minutes`}
            choices={[
              { id: '0', name: '0 นาที' },
              { id: '15', name: '15 นาที' },
              { id: '30', name: '30 นาที' },
              { id: '45', name: '45 นาที' },
            ]}
            onChange={handleMinutesChange}
            defaultValue={servicedurationminutes}
            fullWidth
            validate={[required(), validateServiceDuration]}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            source='key'
            label={`${SERVICES_FIELDS}.key`}
            fullWidth
            validate={[required()]}
            // disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput
            source='type'
            label={`${SERVICES_FIELDS}.type_of_service.label`}
            choices={[
              { id: 'main', name: 'บริการ' },
              { id: 'other', name: 'บริการอื่นๆ' },
            ]}
            fullWidth
            validate={[required()]}
            sx={{ mt: 0 }}
          />
        </Grid>
        <Grid item xs={2}>
          <BooleanInput
            color='primary'
            source='is_active'
            label={`${COMMON_FIELDS}.status.label`}
          />
        </Grid>
      </Grid>
    </SimpleForm>
  )
}

const ServiceEdit = (): JSX.Element => {
  const transformEmailConfig = (data): object => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,
    const { ...transformData } = data
    return transformData
  }
  return (
    <EditBase
      title={`${PREFIX}.edit.title`}
      encType='application/json'
      actions={false}
      listAction={{
        hasShow: false,
        hasBackButton: true,
      }}
      transform={transformEmailConfig}
    >
      <EditForm />
    </EditBase>
  )
}

export default ServiceEdit
